import { render, staticRenderFns } from "./MainGroups.vue?vue&type=template&id=624a6ac6&scoped=true"
import script from "./MainGroups.vue?vue&type=script&lang=ts"
export * from "./MainGroups.vue?vue&type=script&lang=ts"
import style0 from "./MainGroups.vue?vue&type=style&index=0&id=624a6ac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a6ac6",
  null
  
)

export default component.exports